import { render, staticRenderFns } from "./image.vue?vue&type=template&id=283989ff&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&lang=css&"
import style1 from "./image.vue?vue&type=style&index=1&id=283989ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283989ff",
  null
  
)

component.options.__file = "image.vue"
export default component.exports